export const clearLocalStorage = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("userId")
    localStorage.removeItem("email")
    localStorage.removeItem("roleId")
    localStorage.removeItem("role-token")
    localStorage.removeItem("roleChanged")
    localStorage.removeItem("fabricationFacility")
    localStorage.removeItem("fieldFacility")
    localStorage.removeItem("hangerFacility")
    localStorage.removeItem("isScheduler")
    localStorage.removeItem("shopFacility")
    localStorage.removeItem("miscfabFacility")
    return
}
